module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/passwordprotect/bravenet_password_protect_safely_secure.png";